import React from "react";
import BallotIcon from "@material-ui/icons/Ballot";

function UgovorIcon(props) {
  return <BallotIcon {...props}/>;
}

export default UgovorIcon;
